import { Router, RouterConfiguration } from 'aurelia-router';
import { autoinject, PLATFORM, LogManager, DOM, FEATURE } from "aurelia-framework";
import { EventAggregator, Subscription } from 'aurelia-event-aggregator';
import { AppEvents } from 'core/app-events';

@autoinject()
export class EntityShell {

	constructor(private eventAggregator: EventAggregator) { }

	eventSubscriptions: Array<Subscription> = [];
	logger = LogManager.getLogger("EntityShell");

	//For the splitter
	properties = [{ paneSize: '20%'},{}, ];

    router: Router;

	//This is a fix for the splitter not always resizing correctly when the window resizes.
	//$(function() {
	//	$(window).resize(function () {
	//		var Splitterobj = $("#outterSplitter").ejSplitter("instance");
	//		Splitterobj.refresh();
	//	});
	//})


	removeWindowResizeEvent() {
		PLATFORM.removeEventListener('resize', e => this.onWindowResize());
	}

	addWindowResizeEvent() {
		PLATFORM.addEventListener('resize', e => this.onWindowResize());
	}

	//This is a workaround for the splitter getting confused when the window resizes and the background color covering all text in the details pane.
	onWindowResize() {
		this.logger.info('refreshing splitter');
		var splitterInstance  = $("#outterSplitter").ejSplitter("instance");
		if (splitterInstance) splitterInstance.refresh();
	}


    activate() {
		this.logger.info("activate()");
		this.subscribeToEvents();
		this.addWindowResizeEvent();
    }
    subscribeToEvents(): any {
		this.eventSubscriptions._add(this.eventAggregator.subscribe(AppEvents.DIRECTORY_CHANGED, payload => {
			this.onDirectoryChanged(payload);
		}));
    }
    onDirectoryChanged(payload: any): any {
		this.router.navigate('home');
    }

	deactivate() {
		this.logger.info("deactivate");
		this.unsubscribeFromEvents();
		this.removeWindowResizeEvent();
	}
	private unsubscribeFromEvents() {
		for (let entry of this.eventSubscriptions) {
			entry.dispose();
		}
		this.eventSubscriptions = [];
	}

    configureRouter(config: RouterConfiguration, router: Router) {
        config.title = '';
		config.map([
			{ route: [''], redirect: 'entity'},
            //{ route: ['home'], name: 'home',  moduleId: PLATFORM.moduleName('pages/entity/entity-home') },
            { route: ['entity/:id?'], name: 'entity', moduleId: PLATFORM.moduleName('pages/entity/entity') }
        ]);

        this.router = router;
    }

    

    
}




